import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { ui } from '../data/translations';
import { Lang } from '../types/i18n';
const langs: Lang[] = ['en', 'es'];
export function LanguageToggle() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t(ui.common.language)} className="inline-flex rounded-full bg-white/10 p-1" data-id="element-164" data-mp="2y4h772dal5vv">
      {langs.map(l => {
      const active = lang === l;
      return <button key={l} type="button" onClick={() => setLang(l)} aria-pressed={active} lang={l} className={`h-10 min-w-[44px] rounded-full px-3 text-xs font-bold uppercase tracking-wide transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold ${active ? 'bg-gold text-navy-deep' : 'text-white/75 hover:bg-white/10 hover:text-white'}`} data-id="element-165" data-mp="25fthmulifuci">
            {l}
          </button>;
    })}
    </div>;
}